<template>
    <div class="users box-white-wrapper">
        <vs-table search :data="users" pagination max-items="10">
            <template slot="header">
                <vs-button color="primary" @click="openModal()" type="border" icon="library_add">Crear Usuario</vs-button>
            </template>
            <template slot="thead">
                <vs-th sort-key="name">Nombre </vs-th>
                <vs-th sort-key="email">Email </vs-th>
                <vs-th sort-key="role"> Role </vs-th>
                <vs-th sort-key="status"> Estado </vs-th>
                <vs-th sort-key="id" class=""></vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].name">
                        {{data[indextr].name+" "+data[indextr].lastname}}
                    </vs-td>
                    <vs-td :data="data[indextr].email">
                        {{data[indextr].email}}
                    </vs-td>
                    <vs-td :data="data[indextr].role">
                        {{data[indextr].role}}
                    </vs-td>
                    <vs-td :data="data[indextr].status">
                        <div :class="['circle', data[indextr].st01Code === 1 ? 'success' : 'danger']"></div>
                    </vs-td>
                    <vs-td :data="data[indextr].id">
                        <div class="table-actions">
                            <a href="javascript:void(0)" class="" @click="editUser(data[indextr].id)"><feather type="edit-2"/></a>
                            <a href="javascript:void(0)" class="" @click="openConfirmDialog(data[indextr].id)" v-if="data[indextr].st01Code === 1 "><feather type="trash"/></a>
                            <a href="javascript:void(0)" class="" @click="openConfirmDialog(data[indextr].id)" v-if="data[indextr].st01Code === 0 "><feather type="check-circle"/></a>
                            
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
         <transition name="fade">
            <modalBasic :show="ModalActive">
                <div class="modal-header" slot="modal-header">{{ ModalTitle }}</div>
                <div class="modal-body limit-body" slot="modal-body">
                    <form>
                        <div :class="['form-input', {'has-error': $v.user.name.$error }]" >
                            <vs-input label="Nombre" v-model.trim="$v.user.name.$model"/>
                            <span class="error-text" v-if="$v.user.name.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.user.lastName.$error }]" >
                            <vs-input label="Apellidos" v-model.trim="$v.user.lastName.$model"/>
                            <span class="error-text" v-if="$v.user.lastName.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.user.email.$error || checkMail}]" >
                            <vs-input label="Correo Electrónico" v-model.trim="$v.user.email.$model" @change="existEmail" :disabled="isUpdating"/>
                            <span class="error-text" v-if="$v.user.email.$email"><feather type="info" />E-mail Invalido</span>
                            <span class="error-text" v-if="checkMail"><feather type="info" /> {{ errorExistMail}}</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.user.role.$error }]" >
                            <label class="vs-input--label">Role</label>
                            <select-input :options="roles" v-model="$v.user.role.$model"></select-input>
                            <span class="error-text" v-if="$v.user.role.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div class="switch-pass" v-if="isUpdating">
                            <label class="">Actualizar Contraseña</label>
                            <vs-switch v-model="showPassInput"/>
                        </div>
                        <div :class="['form-input', {'has-error': $v.user.password.$error }]" v-show="showPassInput">
                            <vs-input label="Contraseña" type="password" v-model.trim="$v.user.password.$model"/>
                            <span class="error-text" v-if="!$v.user.password.minLength"><feather type="info" /> La Contraseña debe tener al menos{{ $v.user.password.$params.minLength.min }} caracteres.</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.user.repeatPassword.$error }]" v-show="showPassInput">
                            <vs-input label="Confirmar Contraseña" type="password" v-model.trim="$v.user.repeatPassword.$model"/>
                            <span class="error-text" v-if="$v.user.repeatPassword.$error"><feather type="info" />Las contaseñas no coinciden.</span>
                        </div>
                    </form>
                </div>
                <div class="modal-footer" slot="modal-footer">
                    <vs-button color="danger" type="border" icon="block"  @click="closeModal()">Cancelar</vs-button>
                    <vs-button :disabled="confirmStatus || $v.$invalid" id="btnConfirm" color="success" type="border" icon="check" 
                        @click="handleRequestUser" class="vs-con-loading__container"> {{ !isUpdating ? 'Guardar' : 'Actualizar' }}</vs-button>
                </div>
            </modalBasic>
         </transition>
    </div>
</template>
<script>
import UserModel from '@/models/User'
import modalBasic from '@/components/Modal/Basic.vue'
import UserDataService from "@/services/UserDataService"
import SelectInput from '@/components/Form/Select-Input.vue'
import { required, sameAs, minLength, email } from 'vuelidate/lib/validators'
export default {
    name: 'users',
    components: {
      modalBasic,
      SelectInput
    },
    data() {
      return {
        currentx: 5,
        showPassInput: true,
        isUpdating: false,
        confirmStatus: false,
        roles: [
            {
                id: 'Administrator',
                name: "Administrador"
            },
            {
                id: 'Distribuitor',
                name: "Distribuidor"
            }
        ],
        user: new UserModel(),
        ModalTitle: 'Nuevo Usuario',
        ModalActive: false,
        users:[],
        checkMail: false,
        errorExistMail: '',
      }
    },
    validations: {
        user: 
            { 
                name: { required },
                lastName: { required },
                email: { required, email },
                role: { required },
                password: 
                { 
                    required,
                    minLength: minLength(6)
                },
                repeatPassword: { sameAsPassword: sameAs('password') }
            },
    },
    beforeMount() {
        this.$Progress.start();
    },
    mounted () {
      this.retrieveUsers()
    },
    methods:{
        existEmail(){
            this.$v.user.email.$touch()
            console.log('EMAIL ', this.$v.user.email.$invalid)
            if(!this.$v.user.email.$invalid){
                UserDataService.validEmail({email: this.user.email})
                .then(() => {
                    this.checkMail = true
                    this.errorExistMail = 'El email '+ this.user.email+" ya esta registrado."
                    this.user.email   = ""
                })
                .catch(e => {
                    if(e.response.status == 404){
                      this.checkMail = false
                    }else{
                      this.$vs.notify({title:'Información!',text:'Error validando el email',color:'danger',icon:'error_outline'})     
                    }     
                });
            }
        },
        openModal () {
          this.ModalActive = true
          this.isUpdating  = false
          this.user    = new UserModel()
          this.$v.$reset()
        },
        closeModal () {
            this.ModalTitle  = 'Nueva Usuario'
            this.ModalActive = false
            this.user    = new UserModel()
            this.$v.$reset()
            this.showPassInput = true
        },
        editUser (id) {
            this.ModalTitle  = "Editar Usuario"
            this.ModalActive = true
            this.user    = this.searchUser (id)
            this.isUpdating  = true
            this.showPassInput = false
        },
        openConfirmDialog(_id){
            this.user    = this.searchUser (_id)
            let modeText = this.user.status == 1 ? 'desactivar al' : 'activar el'
            this.$vs.dialog({
                type:'confirm',
                title: `¡Atención!`,
                color:'',
                cancelText: 'No',
                acceptText: 'Si',
                iconPack:'home',
                text: '¿Estas seguro de '+modeText+' usuario?',
                accept:this.acceptDeleteUser
            })
        },
        acceptDeleteUser(){
            this.user.status = this.user.status == 1 ? 0 : 1
            UserDataService.update(this.user)
            .then(response => {
                this.confirmStatus = false
                console.log(response)
                this.$vs.loading.close('#btnConfirm .con-vs-loading')
                this.$vs.notify({title:'Creado!',text:'El usuario fue actualizado exitosamente!',color:'success',icon:'check'})
                this.retrieveUsers()
            })
            .catch(e => {
                console.log(e)
                this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                this.confirmStatus = false
                this.$vs.notify({title:'Información!',text:'Error actulizado el estado del usuario',color:'danger',icon:'error_outline'})                
            });
        },
        retrieveUsers() {
            UserDataService.getAll()
            .then(response => {
                this.users = response.data;
                this.$Progress.finish()
            })
            .catch(e => {
                console.log(e);
                this.$Progress.finish()
                this.$vs.notify({title:'Error!',text:'Error obteniendo los usuarios!',color:'danger',icon:'error_outline'})
            });
        },
        handleRequestUser(){
            this.$v.$touch()
            if (this.$v.$invalid) return;
            if (!this.isUpdating) {
                this.saveUser()
            } else {
                this.updateUser()
            }
        },
        loadingProgress (_container, _background = '#28C76F', _color = "#fff") {
            this.$vs.loading({
                background: _background,
                color: _color,
                container: _container,
                scale: 0.45
            })
        },
        saveUser(){
            const that = this
            that.loadingProgress ('#btnConfirm')
            that.confirmStatus = true
            UserDataService.create(that.user)
            .then(response => {
                that.confirmStatus = false
                console.log(response)
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.ModalActive = false
                that.$vs.notify({title:'Creado!',text:'El usuario fue creado exitosamente!',color:'success',icon:'check'})
                that.user    = new UserModel()
                this.$v.$reset()
                this.retrieveUsers()
            })
            .catch(e => {
                console.log(e)
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.confirmStatus = false
                that.$vs.notify({title:'Información!',text:'Error creando el usuario',color:'danger',icon:'error_outline'})                
            });
        },
        updateUser(){
            const that = this
            that.loadingProgress ('#btnConfirm')
            that.confirmStatus = true
            that.user.changepass    = this.showPassInput == true ? 1 : 0
            UserDataService.update(that.user)
            .then(response => {
                that.confirmStatus = false
                this.users.push(this.user)
                console.log(response)
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.ModalActive = false
                that.$vs.notify({title:'Información!',text:'El usuario fue modificado exitosamente!',color:'success',icon:'check'})
                that.user    = new UserModel()
                this.retrieveUsers()
                this.$v.$reset()
            })
            .catch(e => {
                console.log(e)
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.confirmStatus = false
                that.$vs.notify({title:'Información!',text:'Error actualizando el usuario',color:'danger',icon:'error_outline'})
            });
        },
        searchUser (_userid) {
            let objUser = this.users.filter((item) => {
              return _userid === item.id
            })
            objUser =  objUser[0]
            let _role = {id:objUser.role, name: objUser.name}
            let user = new UserModel(objUser.id, objUser.name,  objUser.lastname, objUser.email, _role, objUser.profileUrl, false, objUser.email, objUser.email, objUser.st01Code)
            console.log('s', user)
            return user
        },
    }
}
</script>
